/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BookReason } from '../../models/book-reason';

export interface GetReasonsToExclude$Params {
  bookId: string;
}

export function getReasonsToExclude(http: HttpClient, rootUrl: string, params: GetReasonsToExclude$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BookReason>>> {
  const rb = new RequestBuilder(rootUrl, getReasonsToExclude.PATH, 'get');
  if (params) {
    rb.path('bookId', params.bookId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BookReason>>;
    })
  );
}

getReasonsToExclude.PATH = '/api/configuration/book/{bookId}/reasons';
